import axios from "axios";
import { getCookie } from "@/helpers/helpers";

export default {
    async requestNewPass({ commit, state }) {
        commit('loadingResetPass');

        try {
            const response = await axios.put(`${process.env.VUE_APP_BACKEND_API}/change-pass/`, state.data);
            commit('successResetPass');
            commit('resetSuccessResetPass');
            return true;
        } catch(error) {
            commit('errorResetPass', error.response.data);
            return false;
        }
    },
};
